<template>
  <div class="tab-body">
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="80px">
        <el-row>
          <el-col :span="3">
            <el-button type="primary" v-has-permission-code-and="'0040002000000005'" @click="toSave()">添加</el-button>
            <el-button type="danger" v-has-permission-code-and="'0040002000000000'"
              @click="batchRemove()">批量删除</el-button>
          </el-col>
          <el-col :span="4">
            <el-form-item label="班级名称">
              <el-input v-model="searchParams.cname"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="考试类型">
              <select-option-dictionary @change="chgType()" v-model="searchParams.type"
                dkey="exam-type"></select-option-dictionary>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="试卷">
              <el-input v-model="searchParams.pname"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="科目">
              <el-input v-model="searchParams.kname"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button @click="clearSearchVal">清空</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <el-table class="table" :data="listData.records" stripe border height="auto" @selection-change="selectionChange"
        v-loading="listLoading">
        <el-table-column type="selection" width="55" fixed="left"></el-table-column>
        <el-table-column prop="cname" width="138" label="班  级"></el-table-column>
        <el-table-column prop="name" label=" 名称/科目">
          <template slot-scope="scope">
            <p :title="'考试名称：'+scope.row.name">{{ scope.row.name }}<el-tag type="primary" v-if="scope.row.sbname" size="mini"> ~ {{ scope.row.sbname }}
            </el-tag>  </p>
            <el-tag  v-for="stu in  JSON.parse(scope.row.sid)" type="warning"  size="mini">{{ stu }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="exampName" label="试卷名称">
        </el-table-column>
        <el-table-column prop="startTime" width="140" label="考试时间">
          <template slot-scope="scope">
            <el-tag type="success" size="mini">{{ scope.row.startTime }} </el-tag><el-tag type="danger" size="mini">{{
              scope.row.endTime }} </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="type" width="100" label="类型">
          <template slot-scope="scope">
            <el-tag type="info" v-if="scope.row.type == 1" size="mini">线下考试
            </el-tag>
            <el-tag type="warning" v-else-if="scope.row.type == 2" size="mini">模拟面试
            </el-tag>
            <el-tag type="warning" v-else-if="scope.row.type == 3" size="mini">作业
            </el-tag>
            <el-tag type="danger" v-else-if="scope.row.type == 4" size="mini">面试轮询
            </el-tag>
            <el-tag type="danger" v-else-if="scope.row.type == 5" size="mini">覆盖
            </el-tag>
            <el-tag type="danger" v-else-if="scope.row.type == 6" size="mini">阶段
            </el-tag>
            <el-tag type="success" v-else size="mini">线上 </el-tag>
            <el-tag size="mini" type="danger" v-if="scope.row.isMobile == 1">移动端</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createname" width="100" label="主考"></el-table-column>
        <el-table-column prop="sie" width="130" label="批改/已做/应做">
          <template slot-scope="scope">
            {{ scope.row.judgedsum ? scope.row.judgedsum : 0 }} /
            {{ scope.row.studysum }} /
            <span :title="scope.row.sid">
              {{ scope.row.sid.split(",").length }}</span>
          </template>
        </el-table-column>
 
        <el-table-column label="操作" fixed="right" width="300px">
          <template slot-scope="scope">
            <div class="dataTable-operator">
              <el-button size="mini" icon="el-icon-search" @click="toDetail(scope.$index, scope.row)">
              </el-button>

              <el-button size="mini" v-has-permission-code-and="'0040002000000005'"
                v-if="(!isShowMianshi(scope.row)) && (scope.row.studysum == 0)"
                @click="toUpdate(scope.$index, scope.row)">编辑
              </el-button>
              <el-button size="mini" v-has-permission-code-and="'0040002000000005'"
                :type="scope.row.judgedsum == scope.row.studysum ? 'success' : 'warning'" v-else-if="scope.row.type!=4 && scope.row.studysum > 0 "
                @click="tocorrect(scope.$index, scope.row)"> {{ scope.row.judgedsum == scope.row.studysum ? '查看' : '批改' }}
              </el-button>
              <el-button size="mini" v-has-permission-code-and="'0040002000000005'"
                        type="success" v-else-if="scope.row.type==4 && scope.row.judgedsum > 0 " @click="tocorrect(scope.$index, scope.row)"> 查看
              </el-button>

              <el-button size="mini" v-has-permission-code-and="'0040002000000005'" type="warning"
                v-show="(scope.row.sid.split(',').length) > (scope.row.judgedsum ? scope.row.judgedsum : 0)"
                v-if="isShowMianshi(scope.row)" @click="tocorrect2(scope.$index, scope.row)">考试
              </el-button>
              <el-button size="mini" v-has-permission-code-and="'0040002000000000'" icon="el-icon-download" type="primary"
                v-if="scope.row.type == 1" @click="download(scope.row.expid)">
              </el-button>

              <el-button size="mini" v-has-permission-code-and="'0040002000000000'" type="warning"
                v-if="scope.row.type == 1 && scope.row.studysum == 0" @click="tocorrect3(scope.$index, scope.row)">登分
              </el-button>

              <el-button size="mini" icon="el-icon-delete" type="danger" v-if="isShowDel(scope.row)"
                @click="remove(scope.$index, scope.row)"></el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBar">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
          :page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"></el-pagination>
      </div>
    </div>

    <edit ref="edit"></edit>
    <add ref="add"></add>
    <correct ref="correct"></correct>
    <correct2 ref="correct2"></correct2>
    <correct3 ref="correct3"></correct3>
    <studetail ref="studetail"></studetail>

    <addPaper ref="addPaper"></addPaper>
  </div>
</template>
<script>
import edit from "./edit.vue";
import add from "./add.vue";
import addPaper from "./addPaper.vue";
import correct from "./correct.vue";
import correct2 from "./correct2.vue";
import correct3 from "./correct3.vue";
import studetail from "./correct4.vue";
import api from "@/api/exams/exams/exams.js";
import FillInTheBlanks from "@/components/exams/FillInTheBlanks.vue";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";

export default {
  name: "exams",
  components: {
    edit,
    correct,
    correct2,
    correct3,
    add,
    addPaper,
    studetail,
    FillInTheBlanks,
    selectOptionDictionary,
  },
  data() {
    return {
      searchParams: {},
      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
      selected: [],
      me: "", //操作人
      page: new this.$constant.pageObj(),
    };
  },
  watch: {
    // "searchParams.name": function () {
    // 	this.search();
    // }
  },
  methods: {
    isShowDel(row) {
      if (this.me.role == "ad") {
        return true;
      } else if (this.me.name == row.createname) {
        if (row.judgedsum && row.judgedsum > 0) {
          return false;
        } else {
          return true;
        }
      }
      return false;
    },
    chgType() {
      this.search();
    },
    // 下载线下考试文件
    download(id) {
      let params = { id: id };
      api.downloadWord(params);
    },
    isShowMianshi(exm) {
      if (exm.type == 2 ) {
        //当前时间
        let now = new Date().getTime();
        let start = new Date(exm.startTime).getTime();
        let end = new Date(exm.endTime).getTime();
        if (now > start && start < end) {
          return true;
        }
      }
     // console.log("isShowMianshi = false",exm.name)
      return false;
    },
    //获取数据
    list() {
      this.listLoading = true;
      let params = this.$utils.merger(this.searchParams, this.page);
      api.list(params, (response) => {
        this.listData =response.data;
        this.listLoading = false;
      });
    },

    tocorrect(index, row) {
      if (row.type == 1) {    //去批改
        this.$refs.correct3.open(row.id, row.cname + "~线下考试 - " + row.name);
      } else if ( row.type == 2 || row.type == 4 ) {
        //  去查看  问答
        /* this.$notify({
          title: "提示",
          message: JSON.stringify(row),
          duration: 0,
        }); */
        this.$refs.studetail.open(row.id, row.sid, "查看考生考试结果")
      } else {
        //this.$refs.correct.open(row.id, "批改 - " + row.name);
        this.$refs.correct.open(row, "批改 - " + row.name);
      }
    }, //去面试考核
    tocorrect2(index, row) {
      this.$refs.correct2.open(row.id, "面试考核 - " + row.name);
    },
    tocorrect3(index, row) {
      this.$refs.correct3.open(
        row.id,
        row.cname + "~线下考试登分 - " + row.name
      );
    },
    //去添加
    toAddPaper(formParameter, examIds) {
      //	this.$refs.edit.open({}, '添加试卷', false, '80%');
      this.$refs.addPaper.open(
        formParameter,
        examIds,
        formParameter.type*1==1?"添加线下试卷":"添加覆盖试卷",
        false,
        "90%"
      );
    },
    //去添加
    toSave() {
      this.$refs.add.open({}, "添加");
    },
    //去编辑
    toUpdate(index, row) {
      let editParameter = {
        id: row.id,
      };
      this.$refs.edit.open(editParameter, "编辑");
    },
    //去详情
    toDetail(index, row) {
      let detailParameter = {
        id: row.id,
      };
      this.$refs.edit.open(detailParameter, "详情", true);
    },
    //删除
    remove(index, row) {
      let parameter = {
        ids: row.id,
      };
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //批量删除
    batchRemove() {
      if (!this.selected || this.selected.length == 0) {
        this.$utils.msg.info("请选择至少一行");
        return;
      }
      let parameter = {
        ids: this.selected,
      };
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          {
            ids: this.selected,
          },
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //改变选择项
    selectionChange(val) {
      //清空
      this.selected = [];
      for (let item of val) {
        this.selected.push(item.id);
      }
    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },
    search() {
      this.page.current = 1;
      this.list();
    },
    //清空搜索框
    clearSearchVal() {
      this.searchParams = {};
      this.list();
    },
  },
  mounted() {
    this.list();
    this.me = this.$caches.user.get();
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
</style>

